import {
  NgModule
} from '@angular/core';
import {
  ClientsComponent
} from './clients.component';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  GridModule
} from '@progress/kendo-angular-grid';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../shared/common';
import {
  ClientsService
} from './clients.service';
import {
  LoadingIndicatorModule
} from '../shared/layout/components/loading-indicator';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb';
import {MatExpansionModule} from '@angular/material/expansion';
import {ClientDialogComponent} from '../accounts/detail/components/client-dialog/client-dialog.component';

@NgModule({
  declarations: [
    ClientsComponent
  ],
  imports: [
    ButtonsModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule,
    MatExpansionModule
  ],
  providers: [
    ClientsService
  ],
  entryComponents: [
    ClientDialogComponent
  ]
})
export class ClientsModule {
}
